/**
 * Browser online/offline helpers for POS sync.
 */

export function isBrowserOnline() {
  if (typeof navigator === "undefined") return true;
  return navigator.onLine !== false;
}

/**
 * True when the failure looks like no network / no server response / CORS block
 * (not a 4xx/5xx business error).
 */
export function isNetworkError(error) {
  if (!error) return false;
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  if (error.code === "ERR_NETWORK") return true;
  if (error.code === "ECONNABORTED") return true;
  const msg = String(error.message || "").toLowerCase();
  if (msg.includes("network error")) return true;
  if (msg.includes("cors")) return true;
  if (msg.includes("failed to fetch")) return true;
  // Axios: request was sent but no HTTP response arrived (includes CORS)
  if (error.request && !error.response) return true;
  return false;
}

/**
 * Subscribe to online/offline changes. Returns an unsubscribe function.
 * @param {(online: boolean) => void} listener
 */
export function subscribeConnectivity(listener) {
  if (typeof window === "undefined") return () => {};

  const onOnline = () => listener(true);
  const onOffline = () => listener(false);

  window.addEventListener("online", onOnline);
  window.addEventListener("offline", onOffline);

  return () => {
    window.removeEventListener("online", onOnline);
    window.removeEventListener("offline", onOffline);
  };
}
